import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { formatDate } from "config/constant";

const ProgramCampaign = memo(props => {
	const classes = useStyles();
	const { listCampaign, handleClickProgramCampaign } = props;

	const showLogoCampaign = type => {
		switch (type) {
			case "PRODUCT_GIFT":
				return Images.logoCampaignGift;
			case "DISCOUNT_BILL":
				return Images.logoCampaignPercent;
			case "MONEY_GIFT":
				return Images.logoMoney;
			default:
				return Images.logoOther;
		}
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.title }}>
				<img src={Images.titleCampaign} alt={"titleCampaign"} />
			</Grid>
			{listCampaign.map(product => (
				<Grid
					container
					classes={{ root: classes.body }}
					key={product?.id}
					onClick={() => handleClickProgramCampaign(product.id)}
				>
					<Grid item xs={4} classes={{ root: classes.logo }}>
						<Grid
							classes={{ root: classes.bgLogo }}
							style={{
								backgroundImage: `url(${showLogoCampaign(
									product?.type
								)})`
							}}
						/>
					</Grid>
					<Grid item xs={8} classes={{ root: classes.program }}>
						<Grid classes={{ root: classes.borderTitle }}>
							<Grid classes={{ root: classes.titleProgram }}>
								{product?.name}
							</Grid>
							<img src={Images.icInfoBlue} alt="icInfoBlue" />
						</Grid>
						<Grid classes={{ root: classes.discription }}>
							<div
								style={{
									marginBottom: "10px",
									whiteSpace: "pre-wrap"
								}}
								dangerouslySetInnerHTML={{
									__html: product?.description
								}}
							/>
						</Grid>
						<Grid classes={{ root: classes.time }}>
							<img src={Images.icClock} alt="icClock" />{" "}
							{`Từ ${formatDate(
								product?.startTime
							)} - ${formatDate(product?.endTime)}`}
						</Grid>
					</Grid>
				</Grid>
			))}
		</Grid>
	);
});

export default ProgramCampaign;
